import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WithRender from './GridCheckOut.html';
import config from '@/settings/config.js';
import { CartLine, InitiatePayment, PaymentGateWay, RecepientDetail, RequiredPaymentDetail } from '@/types/CartTypes';
import shoppingCart from '@/store/modules/shoppingCart'

import { mapGetters } from 'vuex';
import { CartLineItem } from '@/types/productGridTypes';

@WithRender
@Component({
  components: {
    Loading,
  },
  computed: {
    ...mapGetters("shoppingCart",
    {  paymentGateWay: "getPaymentGateWayDto"}),
    ...mapGetters("productGridStore", {
      itemsInCart: "cartLineItemArr",
      totalAmount: "cartTotalAmount",
      requiredPaymentDetail: "getRequiredPaymentDetail"
    }),
    ...mapGetters("recepientDetail",
      { recepient: "getRecepient" })
  }
})
export default class GridCheckOut extends Vue {

  productInCart = {} as CartLine;
  paymentGateWay!: PaymentGateWay;
  initiatePayment = {} as InitiatePayment;

  itemsInCart!: CartLineItem[];
  totalAmount!: number;
  recepient!: RecepientDetail;
  requiredPaymentDetail!: RequiredPaymentDetail;

  isLoading = false;
  fullPage = true;
  paymentMethod = "wallet";
  ShowCouponBox = false;
  showPaymentMethods = !config.isMobile;

  payment!: {
    payfasturl: string;
  } | null;

  private getAllExtra1(): string[] {
    let extra1List: any = [];
    this.itemsInCart.forEach(item => {
      extra1List.push({ extra1: item.row.extra1, count: item.count })
    });
    return extra1List;
  }

  private setInitiatedValues(signingParty: string): void {
    this.isLoading = true;
    this.initiatePayment.rateKey = this.requiredPaymentDetail.key;
    this.initiatePayment.portfolio = this.requiredPaymentDetail.portFolio;

    this.initiatePayment.recepientMobile = this.recepient.receiverNumber;
    this.initiatePayment.accountNo = this.recepient.receiverNumber;
    this.initiatePayment.senderMobile = this.recepient.senderNumber;

    this.initiatePayment.extra2 = JSON.stringify({
      firstName: this.recepient.firstName,
      middleName: this.recepient.middleName,
      surname: this.recepient.surname
    })

    this.initiatePayment.signingParty = signingParty;
    this.initiatePayment.isoCountry = this.requiredPaymentDetail.isoCountry;
    this.initiatePayment.extra1 = JSON.stringify(this.getAllExtra1());
    this.initiatePayment.location = this.requiredPaymentDetail.groceryLocation;
    this.initiatePayment.itemName = "Grocery";
    this.initiatePayment.itemDescription = "Grocery";
  }

  private async preparePayment(signingParty: string) {
    try{
    await this.$store.dispatch("shoppingCart/initiatePayment", this.initiatePayment);
    this.submitPayment(signingParty)
    }
    catch(error)
    {
      console.error(error);
    }
    this.isLoading = false;
  }

  GetPaymetURL() {
    if (this.payment == null)
      return;
    return this.payment.payfasturl + this.paymentMethod;
  }

  paymentMethodStrategy() {
    let signingParty = "payfast"
    if (this.paymentMethod === "wallet") {
      signingParty = "wallet"
    }
    this.setInitiatedValues(signingParty);
    this.preparePayment(signingParty);
  }

  private submitPayment(signingParty: string) {
    if (signingParty === "payfast")
      (<HTMLFormElement>document.querySelector("#payfast")).submit();
    else
      this.$router.push("Credit");
  }
}